// ════════════════════════════════════════════════════════════════════
//  THEME REGISTRY + THE ONE SWITCH
//  Each theme is a folder with palette.js + global.js. To add a template,
//  duplicate a folder, edit it, register it below. To switch the WHOLE app's
//  look, change ACTIVE_THEME (one line). "default" is your original look and is
//  never modified — so switching back is always instant.
// ════════════════════════════════════════════════════════════════════
import * as defaultPalette from "./default/palette";
import { globalCss as defaultCss } from "./default/global";
import * as applePalette from "./apple-native/palette";
import { globalCss as appleCss } from "./apple-native/global";

const THEMES = {
  "default":      { palette: defaultPalette, globalCss: defaultCss },
  "apple-native": { palette: applePalette,   globalCss: appleCss },
};

// ⬇⬇⬇  CHANGE THIS ONE STRING TO SWITCH THE LOOK  ⬇⬇⬇
export const ACTIVE_THEME = "apple-native";   // "default" | "apple-native"

export const theme = THEMES[ACTIVE_THEME] || THEMES["default"];
